/**
 * Canicule : air/wind burst particles on designated button clicks
 * Respects prefers-reduced-motion · max 3 concurrent bursts
 */
(function () {
  'use strict';

  var MAX_CONCURRENT = 3;
  var activeBursts = 0;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var VARIANTS = {
    breeze: { count: 10, duration: 600, spread: 72, distance: 52 },
    mist: { count: 12, duration: 600, spread: 90, distance: 40 },
    pulse: { count: 8, duration: 500, spread: 360, distance: 36 },
    stream: { count: 10, duration: 600, spread: 28, distance: 64 }
  };

  var INTENSITY = {
    low: { countMul: 0.7, distanceMul: 0.75 },
    medium: { countMul: 1, distanceMul: 1 },
    high: { countMul: 1.25, distanceMul: 1.2 }
  };

  function getCenter(el) {
    var rect = el.getBoundingClientRect();
    return {
      x: rect.left + rect.width / 2 + window.scrollX,
      y: rect.top + rect.height / 2 + window.scrollY
    };
  }

  function flashButton(el) {
    el.classList.add('canicule-airburst--flash');
    window.setTimeout(function () {
      el.classList.remove('canicule-airburst--flash');
    }, 220);
  }

  function createParticle(type, angle, distance, index) {
    var particle = document.createElement('span');
    particle.className = 'canicule-airburst__particle canicule-airburst__particle--' + type;
    particle.style.setProperty('--burst-angle', angle + 'deg');
    particle.style.setProperty('--burst-distance', distance + 'px');
    particle.style.setProperty('--burst-delay', index * 18 + 'ms');

    if (type === 'stream') {
      particle.style.setProperty('--burst-angle', '0deg');
      particle.style.setProperty('--burst-offset-y', (Math.random() * 24 - 12) + 'px');
    }

    return particle;
  }

  function emitBurst(el, type, intensity) {
    if (activeBursts >= MAX_CONCURRENT) return;

    var variant = VARIANTS[type] || VARIANTS.breeze;
    var scale = INTENSITY[intensity] || INTENSITY.medium;
    var count = Math.round(variant.count * scale.countMul);
    var distance = variant.distance * scale.distanceMul;
    var center = getCenter(el);

    var layer = document.createElement('div');
    layer.className = 'canicule-airburst__layer';
    layer.setAttribute('aria-hidden', 'true');
    layer.style.left = center.x + 'px';
    layer.style.top = center.y + 'px';
    layer.style.setProperty('--burst-duration', variant.duration + 'ms');

    for (var i = 0; i < count; i++) {
      var angle;
      if (type === 'stream') {
        angle = 0;
      } else if (type === 'pulse') {
        angle = (360 / count) * i;
      } else {
        var half = variant.spread / 2;
        angle = -90 - half + (variant.spread / (count - 1 || 1)) * i;
      }
      var dist = distance * (0.65 + Math.random() * 0.45);
      layer.appendChild(createParticle(type, angle, dist, i));
    }

    document.body.appendChild(layer);
    activeBursts += 1;

    window.setTimeout(function () {
      if (layer.parentNode) layer.parentNode.removeChild(layer);
      activeBursts = Math.max(0, activeBursts - 1);
    }, variant.duration + 120);
  }

  function trigger(el) {
    if (!el || !el.hasAttribute('data-canicule-airburst')) return;

    if (reducedMotion) {
      flashButton(el);
      return;
    }

    var type = el.getAttribute('data-airburst-type') || 'breeze';
    var intensity = el.getAttribute('data-airburst-intensity') || 'medium';
    emitBurst(el, type, intensity);
  }

  function onActivate(e) {
    var el = e.target.closest('[data-canicule-airburst]');
    if (!el) return;
    trigger(el);
  }

  function onKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest('[data-canicule-airburst]');
    if (!el) return;
    if (el.tagName === 'A') return;
    trigger(el);
  }

  document.addEventListener('click', onActivate, true);
  document.addEventListener('keydown', onKeydown, true);

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      var btn = form.querySelector('[type="submit"][data-canicule-airburst], [type="submit"]');
      if (!btn) return;

      if (!btn.hasAttribute('data-canicule-airburst')) {
        btn.setAttribute('data-canicule-airburst', '');
        btn.setAttribute('data-airburst-type', 'pulse');
        btn.setAttribute('data-airburst-intensity', 'high');
      }
      trigger(btn);
    },
    true
  );
})();
